import { useState } from "react";
import { EDITOR_VIEW_NAME } from "../core/constants";
import { translate } from "../core/i18n";
import { getViewData, setViewData } from "../core/views";
import { getTemplateFields, setTemplateFields } from "../features/templates";
import { CloseButton } from "./buttons/base/CloseButton";
import { saveUserData } from "../core/code/saver";

export const requestEditData = () => {
  const editorState = getViewData(EDITOR_VIEW_NAME);
  editorState.data = {
    ...editorState.data,
    editDataVisible : true
  }
  setViewData(EDITOR_VIEW_NAME, editorState);
} 

export const EditProjectData = () => {
  const [fieldState, setFieldState] = useState(getTemplateFields());

  const closeEditor = () => {
    const editorState = getViewData(EDITOR_VIEW_NAME);
    editorState.data = {
      ...editorState.data,
      editDataVisible : false
    }
    setViewData(EDITOR_VIEW_NAME, editorState);
  }

  const setFieldValue = (e, key) => {
    const fieldIndex = fieldState.findIndex((item) => item.key === key);
    let field = fieldState[fieldIndex];
    field.value = e.target.value;
    let newFieldState = [ ... fieldState ];
    newFieldState[fieldIndex] = field;

    setFieldState(newFieldState);
  }

  const saveTemplate = () => {
    setTemplateFields(fieldState);
    closeEditor();
    saveUserData();
  }

  //const templateFields = getTemplateFields();

  const fieldInput = fieldState.map((field) => {
    return <div className="row pad-5" key={field.key}>
       <div className="col-2">{ field.text }</div>
       <div className="col-9"><input className="inputField" type="text" value={field.value} onChange={(e) => setFieldValue(e, field.key)}></input></div>
    </div>
    })

  return <div className="container pad-5">
  <div className="row" id="grid" style={{display: 'none'}}>
    <div className="col-11">
      {translate("edit-data-menu")}
    </div>
    <div className="col-1">
      <CloseButton id='btn-close-assets' onClick={closeEditor} />
    </div>
  </div>
  { fieldInput }
  <button className="btn btn-primary" onClick={saveTemplate}>Speichern</button>
</div>;
}